/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-restricted-properties */
/* eslint-disable prefer-exponentiation-operator */
/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MapContainer, TileLayer } from "react-leaflet";
import getCenterOfPolygon from "../../../Utils/getCenterOfPolygon";
import { ExpandButton } from "../../../Core/Components/MapMarkerButtons";
import { TripDetailsDrawer } from "../../../Core/Components/CustomMapMarkerDetails";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
// import CustomMapMarker from "../../../Core/Components/CustomMapMarker";
import { TRIP_STATUS } from "../Data/TripConstants";
import TrikeTrackerSwitch from "../../../Core/Components/TrikeTrackerSwitch";
import TrackerTags from "../../Trikes/phase3/TrackerTags";
import usePermission, {
  useTenantPermission,
} from "../../../Core/hooks/usePermission";
import { PERMISSIONS, TENANT_PERMISSIONS } from "../../Login/constants";
import { LOCATION_FETCH_SOURCE } from "../../Trikes/Data";
// import { generateMockDeviation } from "../../../Utils/getMapData";
import StopCoordinates from "./components/StopCoordinates";
import CompletedTripMapComponents from "./components/CompletedTripMapComponents";
import OngoingTripMapComponents from "./components/OngoingTripMapComponents";
import UpcomingTripMapComponents from "./components/UpcomingTripMapComponents";
import { client } from "../../../Utils/axiosClient";

// const lineOptions = { color: "#135bba" };
const tempCoordinates = [-0.6803741, 34.7569482];
const initialZoomLevel = 12;

// const renderMarkerIcon = (icon, topIcon, colors) => {
//   // eslint-disable-next-line new-cap
//   return new L.divIcon({
//     html: ReactDOMServer.renderToString(
//       <CustomMapMarker
//         position="map"
//         icon={icon}
//         topIcon={topIcon}
//         colors={colors}
//       />,
//     ),
//   });
// };

const TripDetailsMapSection = () => {
  const dispatch = useDispatch();

  const {
    fullScreenMapForTrips,
    currentTrip,
    overallSummaryForTrip,
    loading: tripLoading,
  } = useSelector((state) => state.trips);

  const fastestRouteCoordinates =
    currentTrip?.fastestRouteCoordinates ||
    currentTrip?.fastest_route_coordinates ||
    [];

  const isUpcoming = currentTrip.statusId === TRIP_STATUS.UPCOMING;

  const isCompleted = currentTrip.statusId === TRIP_STATUS.COMPLETED;

  const isOngoing = currentTrip.statusId === TRIP_STATUS.ONGOING;

  const { currentTrike, loading: trikeLoading } = useSelector(
    (state) => state.trikes,
  );

  const [actualRoute, setActualRoute] = useState([]);
  const [stationaryPoints, setStationaryPoints] = useState([]);
  const [showLayers, setShowLayers] = useState(false);
  const [hasMobileData, setHasMobileData] = useState(false);
  const [hasTrikeData, setHasTrikeData] = useState(false);

  // previous use - allLocations
  const { globalLocations, allLocations } = useSelector(
    (state) => state.locations,
  );

  // check if tracker permission exists
  const hasTenantTrikePermission = useTenantPermission([
    TENANT_PERMISSIONS.TRIKE_MODULE_ACCESS,
  ]);

  // check if tracker permission exists
  const hasTrackerPermission = usePermission([PERMISSIONS.TRACKER_SWITCH]);

  const mapRef = useRef(null);
  const stops = currentTrip?.stops || [];
  const stopsId = currentTrip?.stopsId || [];

  const isRoundTrip =
    stopsId.length > 1 && stopsId[0] === stopsId[stopsId.length - 1];

  const effectiveStopsId = isRoundTrip ? stopsId.slice(0, -1) : stopsId;

  const localCurrentTrip = effectiveStopsId
    .map((stopId) => stops.find((stop) => stop.stopId === stopId))
    .filter(Boolean);

  const stopCoordinates = localCurrentTrip?.map((stop) => {
    const currentLocation = globalLocations?.find(
      (location) =>
        location.name === stop.location ||
        location.name === stop.name ||
        location.name === stop.locationName,
    );

    if (currentLocation) {
      return [+currentLocation.lat, +currentLocation.long];
    }

    return [0, 0];
  });

  // const THRESHOLD = 0.0005; // adjust if needed

  const getDistanceInMeters = (lat1, lon1, lat2, lon2) => {
    const R = 6371000; // Earth's radius in meters
    const toRad = (deg) => (deg * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

    return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const filteredStationaryPoints = stationaryPoints.filter((stationary) => {
    // Filter out if duration is less than 10 minutes
    if (stationary.duration_seconds < 600) {
      return false;
    }

    // Filter out if within 100m of any stop
    const isNearStop = stopCoordinates.some(([lat, lng]) => {
      return (
        getDistanceInMeters(lat, lng, stationary.lat, stationary.long) < 100
      );
    });

    return !isNearStop;
  });

  const getTrikeAssetLatLngs = () => {
    // no trike permission exists
    if (!hasTenantTrikePermission) {
      const lat = parseFloat(currentTrip?.lat || 0);
      const long = parseFloat(currentTrip?.long || 0);

      return [lat, long];
    }

    // if the switch has mobile location selected, show the lat long stored in trips table
    if (currentTrike?.locationFetchSource == LOCATION_FETCH_SOURCE.MOBILE) {
      const lat = parseFloat(currentTrip?.lat || 0);
      const long = parseFloat(currentTrip?.long || 0);

      return [lat, long];
    }

    // if the switch has TB location selected, show the lat long stored in trikes table
    if (currentTrike?.locationLat != 0 && currentTrike?.locationLong != 0) {
      const lat = parseFloat(currentTrike?.locationLat);
      const long = parseFloat(currentTrike?.locationLong);

      return [lat, long];
    }

    return [-0.6803741, 34.7569482];
  };

  useEffect(() => {
    if (stopCoordinates?.length > 1) {
      mapRef?.current?.setView(
        getCenterOfPolygon(stopCoordinates),
        initialZoomLevel,
      );
    }

    const fetchTrikeRouteAndStationaryPoints = async () => {
      const res = await client.get(
        `${process.env.REACT_APP_API_URL}/trike/get-trike-route-and-stationary-points`,
        {
          params: {
            tripId: currentTrip.id,
          },
        },
      );

      return res;
    };

    (async () => {
      const res = await fetchTrikeRouteAndStationaryPoints();

      setHasMobileData(res?.data?.has_mobile_data || false);
      setHasTrikeData(res?.data?.has_trike_data || false);

      if (res?.data?.route?.length) {
        setActualRoute(
          res?.data?.route
            .filter((coord) => coord?.lat && coord?.long)
            .map((coord) => ({ lat: coord?.lat, lng: coord?.long })),
        );
        setStationaryPoints(res?.data?.stationary_points || []);
      }
    })();
  }, [allLocations]);

  console.log({ trikeLoading, tripLoading }, getTrikeAssetLatLngs());

  // commented as we dont have actual trike coordinates everytime
  // useEffect(() => {
  //   if (!trikeLoading && !tripLoading) {
  //     getTrikeAssetLatLngs();
  //     if (currentTrip.statusId === TRIP_STATUS.ONGOING) {
  //       mapRef?.current?.setView(getTrikeAssetLatLngs());
  //     }
  //   }
  // }, [currentTrike, trikeLoading, tripLoading]);

  // const getCurrentTrikeMarker = () =>
  //   L.divIcon({
  //     html: ReactDOMServer.renderToString(
  //       <svg
  //         width="38"
  //         height="38"
  //         viewBox="0 0 38 38"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <g clipPath="url(#clip0_20844_277032)">
  //           <circle cx="19" cy="19" r="15" fill="#FAD152" />
  //           <path
  //             d="M5.73973 5.73973C-1.57991 13.0594 -1.57991 24.9406 5.73973 32.2603C13.0594 39.5799 24.9406 39.5798 32.2603 32.2603C39.5799 24.9406 39.5799 13.0594 32.2603 5.73973C24.9406 -1.57991 13.0595 -1.57991 5.73973 5.73973ZM28.4856 10.9466L19.389 31.2701C19.2033 31.668 18.8144 31.9155 18.3901 31.9155H18.3547C17.9038 31.9067 17.5149 31.6238 17.3646 31.2082L14.5446 23.4554L6.79175 20.6354C6.37625 20.4851 6.09335 20.0962 6.0845 19.6453C6.0668 19.2033 6.31438 18.7967 6.72988 18.6111L27.0534 9.51447C27.4512 9.32884 27.9463 9.41727 28.2645 9.73549C28.5828 10.0537 28.6711 10.5488 28.4856 10.9466Z"
  //             fill="#085054"
  //           />
  //         </g>
  //         <defs>
  //           <clipPath id="clip0_20844_277032">
  //             <rect width="38" height="38" fill="white" />
  //           </clipPath>
  //         </defs>
  //       </svg>,
  //     ),
  //   });

  return (
    <div className="h-[calc(100vh-128px)]">
      {stopCoordinates?.length > 1 && overallSummaryForTrip?.stopActivities ? (
        <MapContainer
          center={
            stopCoordinates?.length > 1
              ? getCenterOfPolygon(stopCoordinates)
              : tempCoordinates
          }
          zoom={
            currentTrip.statusId === TRIP_STATUS.ONGOING ? 14 : initialZoomLevel
          }
          className="z-10 w-full h-full polyline"
          zoomControl={false}
          ref={mapRef}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <>
            {isCompleted && (
              <CompletedTripMapComponents
                stopCoordinates={stopCoordinates}
                stationaryPoints={filteredStationaryPoints}
                actualRoute={actualRoute}
                fastestRouteCoordinates={fastestRouteCoordinates}
              />
            )}
            {isOngoing && (
              <OngoingTripMapComponents
                stopCoordinates={stopCoordinates}
                actualStopCoordinates={stopCoordinates}
                actualRoute={actualRoute}
                fastestRouteCoordinates={fastestRouteCoordinates}
                filteredStationaryPoints={filteredStationaryPoints}
              />
            )}

            {isUpcoming && (
              <UpcomingTripMapComponents
                stopCoordinates={stopCoordinates}
                fastestRouteCoordinates={fastestRouteCoordinates}
              />
            )}
            {/* stop markers */}
            <StopCoordinates
              stopCoordinates={stopCoordinates}
              overallSummaryForTrip={overallSummaryForTrip}
            />
          </>
        </MapContainer>
      ) : (
        <div />
      )}

      <div className="absolute z-20 w-full left-6 top-20">
        <div className="flex items-center justify-between">
          {/* show tracker information (switch or tag) only if permission exists */}
          {hasTrackerPermission ? (
            <div>
              {currentTrip.statusId === TRIP_STATUS.ONGOING ? (
                <TrikeTrackerSwitch
                  trikeId={currentTrike.id}
                  trikeRegistrationNo={currentTrike.registrationNo}
                  locationFetchSource={currentTrike.locationFetchSource}
                />
              ) : currentTrip.statusId === TRIP_STATUS.COMPLETED ? (
                <TrackerTags
                  hasMobileData={hasMobileData}
                  hasTrikeData={hasTrikeData}
                />
              ) : (
                <div />
              )}
            </div>
          ) : (
            <div />
          )}

          <div className="flex mr-14 gap-x-4">
            <ExpandButton
              onClick={() =>
                dispatch(
                  updateTrips({
                    key: "fullScreenMapForTrips",
                    value: {
                      ...fullScreenMapForTrips,
                      visible: true,
                      polygonCoordinates: stopCoordinates,
                      pointColor: currentTrip?.statusId,
                    },
                  }),
                )
              }
            />
          </div>
        </div>
      </div>
      <div className="absolute bottom-[140px] right-8 z-[1000]">
        <button
          type="button"
          onClick={() => setShowLayers((prev) => !prev)}
          className="w-8 h-8 bg-white rounded-md shadow-lg flex items-center justify-center border border-gray-200 hover:bg-gray-50"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.67172 1.94669L12.6051 3.69336C13.7384 4.19336 13.7384 5.02002 12.6051 5.52002L8.67172 7.26669C8.22505 7.46669 7.49172 7.46669 7.04505 7.26669L3.11172 5.52002C1.97839 5.02002 1.97839 4.19336 3.11172 3.69336L7.04505 1.94669C7.49172 1.74669 8.22505 1.74669 8.67172 1.94669Z"
              stroke="#525252"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 7.33331C2 7.89331 2.42 8.53998 2.93333 8.76665L7.46 10.78C7.80667 10.9333 8.2 10.9333 8.54 10.78L13.0667 8.76665C13.58 8.53998 14 7.89331 14 7.33331"
              stroke="#525252"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 10.6667C2 11.2867 2.36667 11.8467 2.93333 12.1L7.46 14.1134C7.80667 14.2667 8.2 14.2667 8.54 14.1134L13.0667 12.1C13.6333 11.8467 14 11.2867 14 10.6667"
              stroke="#525252"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {showLayers && (
          <div className="absolute bottom-16 right-0 w-[270px] bg-white rounded-2xl shadow-xl overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3 border-b">
              <div className="flex items-center gap-3">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.67172 1.94669L12.6051 3.69336C13.7384 4.19336 13.7384 5.02002 12.6051 5.52002L8.67172 7.26669C8.22505 7.46669 7.49172 7.46669 7.04505 7.26669L3.11172 5.52002C1.97839 5.02002 1.97839 4.19336 3.11172 3.69336L7.04505 1.94669C7.49172 1.74669 8.22505 1.74669 8.67172 1.94669Z"
                    stroke="#525252"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2 7.33331C2 7.89331 2.42 8.53998 2.93333 8.76665L7.46 10.78C7.80667 10.9333 8.2 10.9333 8.54 10.78L13.0667 8.76665C13.58 8.53998 14 7.89331 14 7.33331"
                    stroke="#525252"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2 10.6667C2 11.2867 2.36667 11.8467 2.93333 12.1L7.46 14.1134C7.80667 14.2667 8.2 14.2667 8.54 14.1134L13.0667 12.1C13.6333 11.8467 14 11.2867 14 10.6667"
                    stroke="#525252"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span className="font-aileron font-semibold text-xs leading-none text-dark-gray">
                  Layers
                </span>
              </div>

              <button
                type="button"
                onClick={() => setShowLayers(false)}
                className="text-gray-500 hover:text-black text-2xl leading-none"
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="p-5 space-y-4">
              <div className="flex items-center justify-between">
                <span className="font-aileron font-normal text-xs leading-none text-dark-gray">
                  Planned Route
                </span>

                <div className="flex gap-1">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="w-3 h-1.5 rounded bg-[#4C8A90]" />
                  ))}
                </div>
              </div>

              <div className="flex items-center justify-between">
                <span className="font-aileron font-normal text-xs leading-none text-dark-gray">
                  Actual Route
                </span>

                <div className="w-10 h-2 rounded-full border border-[#4C8A90] bg-[#A8D8D8]" />
              </div>

              <div className="flex items-center justify-between">
                <span className="font-aileron font-normal text-xs leading-none text-dark-gray">
                  Deviated Route
                </span>

                <div className="w-10 h-2 rounded-full border border-[#F25544] bg-[#FFD4CF]" />
              </div>

              <div className="flex items-center justify-between">
                <span className="font-aileron font-normal text-xs leading-none text-dark-gray">
                  Trike Stationary
                </span>

                <div className="w-7 h-7 rounded-full bg-[#FFE8D0] flex items-center justify-center">
                  <div className="w-4 h-4 rounded-full bg-[#F59D2A]" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <TripDetailsDrawer
        mapRef={mapRef}
        initialZoomLevel={initialZoomLevel}
        // center={getCenterOfPolygon(stopCoordinates)}
        center={tempCoordinates}
      />
    </div>
  );
};

export default TripDetailsMapSection;
